import AppShell from '../components/layout/AppShell'

export default function AppPage() {
  return <AppShell />
}
